import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { exportPaymentsExcelUrl } from "@/business/payment/infrastructure/constants/urls";

export const exportPaymentsExcel = {
  async execute(date: string): Promise<string> {
    return getEnvVariable
      .execute("VUE_APP_DACCACH_URL")
      .concat(exportPaymentsExcelUrl)
      .replace("{date}", date);
  },
};
